module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "BEPF"
  }, [_vm._v("He who can read Sir Charles Lyell’s grand work on the "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Principles of Geology")]), _vm._v(", which the future historian will recognise as having produced a revolution in natural science, and yet does not admit how vast have been the past periods of time, may at once close this volume. ")]), _vm._v(" "), _c('p', {
    staticClass: "BEPC"
  }, [_c('br'), _vm._v("— Charles Darwin, "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("On the Origin of Species by "), _c('br'), _vm._v("Means of Natural Selection, or, the Preservation "), _c('br'), _vm._v("of Favoured Races in the Struggle for Life")])]), _vm._v(" "), _c('p', {
    staticClass: "BEPF"
  }, [_vm._v("Your idea regarding the effect of gravity on foetal development is absolutely fascinating, and is of much interest to me … ")]), _vm._v(" "), _c('p', {
    staticClass: "BEPTX"
  }, [_vm._v("There is a great deal of knowledge in the field of foetal development about the importance of physical distorting forces on inducing foetal growth, making your idea of “lighter gravity” affecting foetal life entirely feasible (and to the best of my knowledge absolutely original to boot). Further, the effect of changes of gravity on heart action and blood flow is also fascinating, especially since the foetus is not as well equipped as is its mother. ")]), _vm._v(" "), _c('p', {
    staticClass: "BEPMTX"
  }, [_vm._v("So, malformed foetuses being at risk of dying in utero or at birth is a plausible conjecture. ")]), _vm._v(" "), _c('p', {
    staticClass: "BEPM"
  }, [_vm._v("—Professor Frank Manning ")]), _vm._v(" "), _c('p', {
    staticClass: "BEP"
  }, [_vm._v("Division of Maternal Foetal Medicine ")]), _vm._v(" "), _c('p', {
    staticClass: "BEP"
  }, [_vm._v("New York Medical College ")]), _vm._v(" "), _c('p', {
    staticClass: "BEP"
  }, [_vm._v("New York ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c72e31d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinchesofMars_1P3.vue
// module id = 75
// module chunks = 0